module.exports = __webpack_public_path__ + "static/media/hm.d6ce09e7.svg";